export default __webpack_public_path__ + "static/zonapro-bold-d456562ddb81db47342f1689f9697a47.ttf";